import { AbstractEntityMapper } from '@pf/shared-services';
import {
    PickListCreate,
    PickListDto,
    PickListRead,
    PickListSearchParams,
} from '../../entities/pick-list.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { PickListMetadataMap } from './pick-list.mapping-profile';

@Injectable()
export class PickListMapper extends AbstractEntityMapper<
    PickListRead,
    PickListCreate,
    PickListDto,
    PickListSearchParams
> {
    constructor() {
        super(PickListDto, PlatformWmsMapper, PickListMetadataMap.symbols);
    }
}
